import React from 'react';

import CardDialog from '~/components/CardDialog';
import SkeletonTable from '~/components/core/Skeletons/SkeletonTable';
import SortableTable from '~/components/core/Tables/SortableTable';
import ContactTfnVerificationActionCell from '~/components/Finances/FinanceApprovalsTab/ContactTfnVerificationApprovals/ContactTfnVerificationActionCell';
import useTfnVerificationsPagination from '~/components/Finances/FinanceApprovalsTab/ContactTfnVerificationApprovals/useTfnVerificationsPagination';
import OverflowTextWithToolTip from '~/components/OverflowTextWithToolTip';
import { serverDateTimeToLocal } from '~/DateTimeUtils';
import type { PageDataResponseTfnPendingVerificationItemNoneTypeTfnPendingVerificationItem } from '~/server_shared/openapi/data-contracts';

const RESULTS_PER_PAGE = 10;

const ContactTfnVerificationApprovals: React.FC = () => {
  const { pagination, pageResults, isLoading, isError, reload } = useTfnVerificationsPagination({
    initialRowsPerPage: RESULTS_PER_PAGE,
  });

  const columns = [
    {
      id: 'contact_name',
      label: 'Contact Name',
      disableSort: true,
      specialCell: (row: PageDataResponseTfnPendingVerificationItemNoneTypeTfnPendingVerificationItem) => (
        <OverflowTextWithToolTip maxWidth="200px">{row.contact_name}</OverflowTextWithToolTip>
      ),
    },
    {
      id: 'requesting_user',
      label: 'Requested By',
      disableSort: true,
      specialCell: (row: PageDataResponseTfnPendingVerificationItemNoneTypeTfnPendingVerificationItem) =>
        row.requesting_user,
    },
    {
      id: 'request_datetime',
      label: 'Request Date',
      disableSort: true,
      specialCell: (row: PageDataResponseTfnPendingVerificationItemNoneTypeTfnPendingVerificationItem) =>
        row.request_datetime && serverDateTimeToLocal(row.request_datetime),
    },
    {
      id: 'actions',
      label: 'Actions',
      disableSort: true,
      align: 'right',
      specialCell: (row: PageDataResponseTfnPendingVerificationItemNoneTypeTfnPendingVerificationItem) => (
        <ContactTfnVerificationActionCell row={row} onReload={reload} />
      ),
    },
  ];

  return (
    <CardDialog noCardTitle>
      <div className="p-20">
        <div>
          {isLoading || isError ? (
            <SkeletonTable columnsCount={columns.length} rowsCount={RESULTS_PER_PAGE} isError={isError} />
          ) : (
            <SortableTable
              rows={pageResults}
              columns={columns}
              paginationProps={{
                page: pagination.page,
                rowsPerPage: pagination.rowsPerPage,
                onChangePage: (_: unknown, newPage: number) => {
                  pagination.setPage(newPage);
                },
                disabled: isLoading,
                count: pagination.totalCount,
                rowsPerPageOptions: [RESULTS_PER_PAGE],
              }}
            />
          )}
        </div>
      </div>
    </CardDialog>
  );
};

export default ContactTfnVerificationApprovals;
